import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-job-els',
  templateUrl: './job-els.component.html',
  styleUrls: ['./job-els.component.css']
})
export class JobElsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
